import { Fragment, useEffect, useRef, useState } from 'react';
import { Combobox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon, XCircleIcon } from '@heroicons/react/20/solid';
import { Tooltip, Zoom } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { optionsSearchStudentNotInCourse } from '../../redux/actions/options';


export const ComboBoxSearch = ({
    selected,
    setSelected,
    property = 'description',
}) => {
    const dispatch = useDispatch();
    const params = useParams();
    const idCourse = params?.idCourse || '';
    const { studentsNotInCourse, loadingStudentsNotInCourse } = useSelector((state) => state.options);

    const timeoutRef = useRef(null);


    const handleChange = (value) => {
        setSelected({ ...selected, [property]: value });
    };

    const clearSelection = () => {
        setSelected({ ...selected, [property]: '' });
    };

    const handleInputChange = (e) => {

        const value = e.target.value;

        // Cancelamos el timeout anterior si el usuario sigue escribiendo
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        // Esperamos 500ms desde el último cambio antes de ejecutar la lógica
        timeoutRef.current = setTimeout(() => {

            searchStudentFromServer(value)
            // Aquí puedes hacer fetch, actualizar estado global, etc.
        }, 1000);
    }

    const searchStudentFromServer = (query) => {
        dispatch(optionsSearchStudentNotInCourse(query, idCourse));
    }

    const hasSelection = !!selected?.[property]; // Verificar si hay selección

    return (
        <div className="">
            <Combobox value={selected?.[property]} onChange={(value) => handleChange(value)}>
                <div className="relative mt-1">
                    <div className="relative w-full">
                        <Combobox.Input
                            className="w-full rounded-md border-none py-2 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 focus:bg-indigo-50 sm:text-sm sm:leading-6 capitalize"
                            displayValue={(item) => item?.description || ''}
                            onChange={(e) => handleInputChange(e)}
                            placeholder={'Ingresa el nombre del estudiante'}
                        />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-2 space-x-2">
                            {hasSelection && (
                                <Tooltip title="Eliminar selecion" TransitionComponent={Zoom} placement='top'>
                                    <button
                                        type="button"
                                        onClick={clearSelection}
                                        className="focus:outline-none"
                                    >
                                        <XCircleIcon
                                            className="h-5 w-5 text-gray-300 hover:text-red-500"
                                            aria-hidden="true"
                                        />
                                    </button>
                                </Tooltip>// Solo mostrar el botón de limpiar si hay selección
                            )}
                            <Combobox.Button className="flex items-center">
                                <ChevronUpDownIcon
                                    className="h-5 w-5 text-gray-400"
                                    aria-hidden="true"
                                />
                            </Combobox.Button>
                        </div>
                    </div>
                    <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                        afterLeave={() => { }}
                    >
                        <Combobox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg sm:text-sm z-40">

                            {
                                loadingStudentsNotInCourse ? (
                                    <div className="relative cursor-default select-none py-2 px-4 text-gray-700">
                                        Buscando estudiante...
                                    </div>
                                ) : null
                            }
                            {(studentsNotInCourse.length === 0 && !loadingStudentsNotInCourse) && (
                                <div className="relative cursor-default select-none py-2 px-4 text-gray-700">
                                    No se encontró.
                                </div>
                            )}
                            {(studentsNotInCourse.length > 0 && !loadingStudentsNotInCourse) && (
                                studentsNotInCourse.map((item, index) => (
                                    <Combobox.Option
                                        key={`${item.description}-${index}`}
                                        className={({ active }) =>
                                            `relative cursor-default select-none py-2 pl-10 pr-4 uppercase ${active ? 'bg-indigo-600 text-white' : 'text-gray-900'}`
                                        }
                                        value={item}
                                    >
                                        {({ selected, active }) => (
                                            <>
                                                <span className={`block truncate uppercase ${selected ? 'font-medium' : 'font-normal'}`}>
                                                    {item.description}
                                                </span>
                                                {selected && (
                                                    <span className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-white' : 'text-indigo-600'}`}>
                                                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    </Combobox.Option>
                                ))
                            )}
                        </Combobox.Options>
                    </Transition>
                </div>
            </Combobox>
        </div>
    );
};
